<template>
    <el-card class="box-card" >
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/admin/' }">Admin</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/admin/users'}">Proyectos</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/admin/users/new'}">{{breadcrumb}}</el-breadcrumb-item>
        </el-breadcrumb>
        <br />
        <el-form @submit.native.prevent="save" ref="form" label-position="top" id="user" >
            <el-row type="flex" justify="space-between">
                <el-col :span="11">
                    <el-form-item label="Nombre del proyecto">
                        <el-input v-model="form.project_name"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="11">
                    <el-form-item label="Host">
                        <el-input v-model="form.dbhost"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>
            <el-row type="flex" justify="space-between">
                <el-col :span="6">
                    <el-form-item label="Nombre de la base de datos">
                        <el-input v-model="form.dbname"></el-input>
                    </el-form-item>
                </el-col>

                <el-col :span="6">
                    <el-form-item label="Nombre del usuario base de datos">
                        <el-input v-model="form.dbuser"></el-input>
                    </el-form-item>
                </el-col>
                <el-col :span="6">
                    <el-form-item label="Contraseña del usuario base de datos">
                        <el-input v-model="form.dbpass"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row type="flex" justify="space-between">
                <el-col :span="16">
                    <el-form-item label="Plugins asociados">
                        <el-select v-model="pluginsProject" multiple placeholder="Select" @change="changuePlugin" @remove-tag="deletePlugin">
                            <el-option
                                v-for="(item, index) in plugins"
                                :key="index"
                                :label="item.name"
                                :value="item.id" >
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="24">
                    <br />
                    <button v-if="this.showBottons" type="submit" class="el-button el-button--primary" form="user"><span>{{btn}}</span></button>
                    <el-button v-if="!$route.params.user_id" @click="close()">Cancelar</el-button>
                </el-col>
            </el-row>
        </el-form>
    </el-card>
</template>

<script>
    import sha1 from 'sha1'
	import ApiService from '@/common/api.service'
    export default {
        name: 'projectForm',
        created(){
            if(this.$route.params.project_id){
                this.breadcrumb = 'Editar proyecto'
                this.btn = 'Actualizar'
                this.id = this.$route.params.project_id
                this.getProject()
                this.getPluginsProject()
            }else{
                this.breadcrumb = 'Nuevo proyecto'               
                this.btn = 'Crear'               
            }
            this.getPlugins()
        },
        data() {
            return {
                breadcrumb: false, 
                btn: false,
                id: false,
                
                form: {
                    dbhost: 'localhost',
                    dbname: null,
                    dbuser: null,
                    dbpass: null,
                    token: null,
                    project_name: null,
                },
                dbpass: false,
                showBottons: true,
                delete: false,
                pluginsAPI: null,
                pluginsOLD: null,
                pluginsProject: []
            }
        },
        methods: {
           async getProject(){
				await ApiService.post("admin/project", {
                    token: localStorage.getItem("token"),
                    id: this.id
				}).then(response => {
                    this.form = response.data
                    this.dbpass = response.data.dbpass
				});
            },

            async getPluginsProject(){
				await ApiService.post("admin/plugins-project", {
                    token: localStorage.getItem("token"),
                    project: this.id
				}).then(response => {
                    this.pluginsProject = response.data.map( (e)=>  {
                        return e.id
                    })
                    this.pluginsOLD = response.data	
				});
            },
            async getPlugins(){
				await ApiService.post("admin/plugins", {
                    token: localStorage.getItem("token"),
				}).then(response => {
                    this.pluginsAPI = response.data
				});
            },

            save() {
                if(this.form.project_name  == ''){
                    this.$root.$emit('msgError','El campo Nombre del proyecto es obligatorio')
                    this.error = true 
                    return false
                }else{
                    this.error = false
                }
                if(this.form.dbhost  == ''){
                    this.$root.$emit('msgError','El campo Host es obligatorio')
                    this.error = true 
                    return false
                }else{
                    this.error = false
                }
                if(this.form.dbname  == ''){
                    this.$root.$emit('msgError','El campo nombre de la base de datos es obligatorio')
                    this.error = true
                    return false                     
                }else{
                    this.error = false
                }
                if(this.form.dbuser  == ''){
                    this.$root.$emit('msgError','El campo nombre del usuario base de datos es obligatorio')
                    this.error = true
                    return false                     
                }else{
                    this.error = false
                }
                    if(this.form.dbpass  == ''){
                    this.$root.$emit('msgError','El campo contraseña del usuario base de datos es obligatorio')
                    this.error = true
                    return false                     
                }else{
                    this.error = false
                }
        
                if(this.error == false){
                    if(this.dbpass != this.form.dbpass){
                        ApiService.post("encryp-pass/" + this.form.dbpass, {
                            token: localStorage.getItem("token"),
                        }).then(response => {
                            this.form.dbpass = response.data
                        });
                    }
                    setTimeout(() => {
                        this.id > 0 ? this.update() : this.insert() ; 
                    }, 500);
                }
            },
            async insert(){
				await ApiService.post("admin/add-project", {
                    token: localStorage.getItem("token"),
                    form: this.form
				}).then(response => {
                    if(response.data != 'Algo ha fallado' && response.data != "El usuario ya existe"){
                        this.$root.$emit('msgSuccess', 'Registro insertado')
                        this.id = response.data
                        setTimeout(() => {
                            this.insertPluginsProject()
                        }, 200);
                    }else{
                        this.$root.$emit('msgError', response.data)
                    }	
				});
            },
            async update(){
				ApiService.post("admin/edit-project", {
                    token: localStorage.getItem("token"),
                    id: this.id ,
                    form: this.form
				}).then(response => {
                    if(response.data != 'Algo ha fallado'){
                        this.$root.$emit('msgSuccess', 'Registro actualizado')
                        setTimeout(() => {
                            this.$router.push('/admin/projects');                        
                        }, 1000);               
                    }else{
                        this.$root.$emit('msgError', 'Algo ha fallado')
                    }
				});
            },
            insertPluginsProject(){
                this.plugins.filter((e) => {
                    this.insertPluginProject(e.id)
                });
            },
            async insertPluginProject(e){
                await ApiService.post("admin/add-plugin-project", {
                    token: localStorage.getItem("token"),
                    form : {
                        project_id: this.id,
                        plugin: e
                    } 
                }).then(r => { console.log(r) });
            },
            deletePlugin(e){
                if(this.id) this.delete = e
            },
            changuePlugin(e){
                setTimeout(() => {
                    if(this.id){
                        if(this.delete == false){
                            this.insertPluginProject(e[e.length - 1])
                        }else{
                            this.pluginsOLD.filter( p => {
                                if(this.delete == p.id) {
                                    ApiService.post("admin/delete-plugin-project", {
                                        token: localStorage.getItem("token"),
                                        form : {
                                            project_id: this.id,
                                            plugin: p.id
                                        }
                                    }).then(response => {
                                        this.$root.$emit('msgSuccess','Registro actualizado con éxito')		
                                    });
                                    this.delete = false
                                    this.pluginsProject.map( plugin => {
                                        if(p.id != plugin.id) return plugin
                                    })
                                }
                            })
                        }
                    }                    
                }, 500);
            },
            close(){
                this.$router.push('/admin/projects')
            }
        },
        computed: {
            plugins() {
                return this.pluginsAPI
            }
        }
    }
</script>


// WEBPACK FOOTER //
// src/components/CloudAdmin/forms/project.vue